import {LeasingMonthlyServiceKind, LeasingOneTimeItemKind} from '../../api/types/onlineOfferTypes';

/** The amounts a leasing offer charges only when they happen. */
export type LeasingConditionalCostField =
  | 'excessMileageCost'
  | 'underMileageCredit'
  | 'liabilityInsuranceDeductible'
  | 'comprehensiveInsuranceDeductible';

/** A monthly service, a one-time item or a conditional amount of a leasing offer. */
export type LeasingCostId =
  LeasingMonthlyServiceKind | LeasingOneTimeItemKind | LeasingConditionalCostField;

const LEASING_COST_KEY_PREFIXES: Record<LeasingCostId, string> = {
  MAINTENANCE: 'financialProducts.leasingCosts.maintenanceMonthly',
  WEAR: 'financialProducts.leasingCosts.wearMonthly',
  MAINTENANCE_AND_WEAR: 'financialProducts.leasingCosts.maintenanceAndWearMonthly',
  VEHICLE_TAX: 'financialProducts.leasingCosts.vehicleTaxMonthly',
  LIABILITY_INSURANCE: 'financialProducts.leasingCosts.liabilityInsuranceMonthly',
  COMPREHENSIVE_INSURANCE: 'financialProducts.leasingCosts.comprehensiveInsuranceMonthly',
  TIRES: 'financialProducts.leasingCosts.tiresMonthly',
  INSPECTION: 'financialProducts.leasingCosts.inspectionMonthly',
  RETURN_VALUE_INSURANCE: 'financialProducts.leasingCosts.returnValueInsuranceMonthly',
  VEHICLE_TRANSFER: 'financialProducts.leasingCosts.vehicleTransfer',
  VEHICLE_REGISTRATION: 'financialProducts.leasingCosts.vehicleRegistration',
  VEHICLE_DELIVERY: 'financialProducts.leasingCosts.vehicleDelivery',
  excessMileageCost: 'financialProducts.leasingCosts.excessMileageCost',
  underMileageCredit: 'financialProducts.leasingCosts.underMileageCredit',
  liabilityInsuranceDeductible: 'financialProducts.leasingCosts.liabilityInsuranceDeductible',
  comprehensiveInsuranceDeductible:
    'financialProducts.leasingCosts.comprehensiveInsuranceDeductible',
};

export const getLeasingCostLabelKeys = (id: LeasingCostId) => ({
  labelKey: `${LEASING_COST_KEY_PREFIXES[id]}.label`,
  tooltipKey: `${LEASING_COST_KEY_PREFIXES[id]}.tooltip`,
});
